import { forwardRef, Ref } from 'react'
import * as S from './style'

interface InputProps {
  name: string;
  label?: string;
  value?: string | number;
  onChange?: (value: any) => void;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  htmlType?: string;
  placeholder?: string;
  [key: string]: any; // for rest props
}

const Input = forwardRef<HTMLInputElement, InputProps>(({
  name,
  label,
  value,
  onChange,
  disabled,
  required,
  className,
  htmlType = 'text',
  placeholder,
  ...rest
}, ref: Ref<HTMLInputElement>) => {
  return (
    <S.Wrapper className={className}>
      {label && (
        <S.Label htmlFor={name} title={label}>
          {label}
        </S.Label>
      )}
      <S.Input
        id={name}
        name={name}
        type={htmlType}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        ref={ref as any} // Type assertion needed for styled-components
        {...rest}
      />
    </S.Wrapper>
  );
})

export default Input;
